import { createRouter, createWebHashHistory } from 'vue-router'
import PublicStepOne from "@/views/PublicStepOne.vue";
import PublicStepTwo from "@/views/PublicStepTwo.vue";
import PublicStepThree from "@/views/PublicStepThree.vue";
import PublicStepFour from "@/views/PublicStepFour.vue";

const routes = [
    { path: '/', redirect: '/step1' },
    { path: '/step1', component: PublicStepOne },
    { path: '/step2', component: PublicStepTwo },
    { path: '/step3', component: PublicStepThree },
    { path: '/step4', component: PublicStepFour },
]

const router = createRouter({
    history: createWebHashHistory('/plattegrond/'),
    routes
})

export default router
